var $5a41bb2baa6861e4$exports = {};
$5a41bb2baa6861e4$exports = {
    "breadcrumbs": `Br\xf8dkrummer`
};


export {$5a41bb2baa6861e4$exports as default};
//# sourceMappingURL=da-DK.module.js.map
